import React, { ReactElement, JSXElementConstructor } from 'react';
import styled from 'styled-components';
import { LabelDiv } from '@ui-library/typography';
import AntSelect, { SelectProps } from 'antd/lib/select';
import { CaretDownOutlined } from '@ant-design/icons';
import { FixMe } from '@utils/types';
import { is } from 'typescript-styled-is';
import { MultiSelectContainer, StyledSelect } from './styles';

const { Option } = AntSelect;

const Container = styled.div`
  width: 475px;
  input {
    width: 100%;
  }
`;

export interface Props extends Omit<SelectProps<FixMe>, 'options'> {
  defaultValue?: FixMe;
  required?: boolean;
  label?: string;
  hasError?: boolean;
  options?: { value: FixMe; label: string; disabled?: boolean }[] | string[];
}

const Select = (props: Props) => {
  const {
    defaultValue,
    options,
    disabled,
    value,
    onChange,
    label,
    required,
    loading,
    hasError,
    ...restProps
  } = props;
  const optionsData: FixMe[] =
    (options && typeof options[0] === 'string'
      ? (options as FixMe[]).map((o: string) => ({ label: o, value: o }))
      : options) || [];
  return (
    <Container className="single-select_container" data-testid="selectCont">
      <LabelDiv className="m-b-xs">
        {label}
        {required && (
          <span style={{ color: 'red' }} data-testid="required">
            {' '}
            *
          </span>
        )}
      </LabelDiv>
      <SingleSelectDropdown
        hasError={hasError}
        disabled={disabled || loading}
        loading={loading}
        value={value}
        {...restProps}
        style={{ width: 120 }}
        onChange={onChange}
        suffixIcon={<CaretDownOutlined className="ant-select-suffix" />}
      >
        {optionsData.map((opt: FixMe) => (
          <Option disabled={opt.disabled} value={opt.value} key={opt.value}>
            {opt.label}
          </Option>
        ))}
      </SingleSelectDropdown>
    </Container>
  );
};

export default Select;

export const SingleSelectDropdown = styled(AntSelect)<FixMe>`
  &.ant-select {
    width: 100% !important;
  }
  .ant-select-selector {
    background: #ffffff !important;
    min-height: 48px !important;
    padding-top: 9px !important;
    padding-bottom: 9px !important;
    border-radius: 4px !important;
    border: 1px solid #dedede !important;
    box-shadow: unset !important;
    outline: none !important;
    ${is('hasError')`
      border: 1px solid #EB0000!important;
      color:#EB0000!important;
  `}
  }
  .ant-select-selection-search {
    align-items: center;
    display: flex;
  }
  .ant-select-clear {
    align-content: center !important;
    display: grid !important;
    font-size: 150%;
    width: 20px;
  }
  .ant-select-arrow {
    align-content: center;
    display: grid;
    width: 20px;
    .anticon:not(.ant-select-suffix) {
      pointer-events: none;
    }
  }
`;

export interface SelectV1Props extends SelectProps<FixMe> {
  onChange?: (val: FixMe) => void;
  options?: { label: string; value: string }[];
  disabled?: boolean;
  className?: string;
  showSearch?: boolean;
  showArrow?: boolean;
  placeholder?: string;
  filterOption?: (input: string, option: FixMe) => boolean;
  dropdownClass?: string;
}

export const SelectV1 = ({ dropdownClass, ...props }: SelectV1Props) => (
  <StyledSelect
    dropdownClassName={`ui-select-dropdown ${dropdownClass}`}
    dropdownMatchSelectWidth={false}
    {...props}
  />
);

interface MultiSelectProps<T> {
  selectedOptions?: string[];
  options: T[];
  renderOption: (option: T) => ReactElement;
  onChange: (x: FixMe) => void;
  tagRender?: (props: FixMe) => ReactElement<unknown, string | JSXElementConstructor<unknown>>;
  dropdownClass?: string;
  placeholder?: string;
  showArrow?: boolean;
}

export const MultiSelectSearch = <
  T extends { value: string; label: string; search: string; disabled?: boolean },
>({
  options,
  selectedOptions,
  renderOption,
  onChange,
  tagRender,
  dropdownClass,
  placeholder,
  showArrow,
}: MultiSelectProps<T>) => (
  <MultiSelectContainer
    mode="multiple"
    className="full-width"
    value={selectedOptions}
    optionFilterProp="search"
    onChange={onChange}
    showArrow={showArrow}
    optionLabelProp="label"
    tagRender={tagRender}
    dropdownClassName={dropdownClass}
    placeholder={placeholder}
  >
    {options.map((item) => (
      <Option
        key={item.value}
        value={item.value}
        label={item.label}
        disabled={item.disabled}
        search={item.search}
      >
        {renderOption(item)}
      </Option>
    ))}
  </MultiSelectContainer>
);
